<template>
    <DnRadio class="base-radio">
        <slot />
    </DnRadio>
</template>

<script setup>
import DnRadio from '@digitalnatives/radio';
</script>

<style lang="less" scoped>
.dn-radio.base-radio {
    margin: 0;

    :deep(.dn-radio__custom) {
        height: 1.25rem;
        width: 1.25rem;

        &:after {
            height: .625rem;
            width: .625rem;
        }

        border-color: var(--color-muted-gray);
        box-shadow: none;
    }

    :deep(input[type='radio']:checked + .dn-radio__custom) {
        border-color: var(--color-secondary);

        &:after {
            background-color: var(--color-secondary);
        }
    }

    :deep(.dn-radio__label) {
        .typography-small();
        margin-left: .5rem;
    }
}
</style>